import { LoginSource } from "@arema/components/Classes";

export const USER_AUTH_KEY = 'arema-auth-user';
export const USER_AUTH_TOKENS_KEY = 'arema-auth-tokens';
export const USER_AUTH_EVENT = 'arema-auth-user-login';
export const USER_AUTH_TOKENS_EVENT = 'arema-auth-user-tokens';

export interface AuthTokens{
	source: LoginSource,
	access: string,
	expires: number,
	refresh: string,
	refresh_expires: number,
}

export interface UserLogin{
	user: {
		user_id: number,
		email: string,
		first_name: string,
		last_name: string,
	},
	change_password?: {
		admin: boolean,
		token: string,
	},
	systems: {
		[x: string]: boolean,
	},
	tokens: AuthTokens
}